import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import walkthroughIds from '../../../walkthroughIds';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import NameField from '@/components/forms/new/formikFormFields/NameField';

const ServiceProfileDescShort = ({ darkMode, errors, touched, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.name && touched.name}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Description (Short){' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter a short description.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            id="customShortText"
                            name="customShortText"
                            validate={(value) =>
                                !value && 'Description (Short) is required'
                            }
                            onChange={props.onChange}
                            placeholder="Enter short description"
                            walkthroughid={
                                walkthroughIds.serviceProfiles?.ufDescShort
                            }
                            error={errors.customShortText}
                            {...props}
                        />
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter a short description."
                        ariaLabel="serviceProfiles-descriptionShort-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ServiceProfileDescShort;
